import React from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { makeHeadData, under2camel } from 'lib/commonLib';

import CurrentStatus from 'components/atoms/CurrentStatus';
import NewInput from 'components/atoms/NewInput';
import NewTableContainer from 'components/molecules/NewTable';
import Modal from 'components/organisms/NewModal';
import TargetingSetting from 'components/organisms/TargetingSetting';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import NewCheckbox from 'components/molecules/NewCheckbox';

const MediaDetailPopup = (props) => {
  const {
    modal,
    getParam,
    handleSubmit,
    handleModalClose,
    handleClickSnackbar,
    weightList,
    popupLoading,
  } = props;
  const { open, type, params = {}, data, headerTitle } = modal;
  const { allProductCodeList } = useSelector(({ common }) => ({
    allProductCodeList: common.allProductCodeList,
  }));
  const { t } = useTranslation();
  const isHistoryPage = type === 'history' || type === 'mediaHistory';

  const historyHead = [
    {
      id: 'REG_DTTM',
      label: '날짜',
      orderFlag: false,
      displayFlag: false,
    },
    {
      id: 'STATE',
      label: '상태',
      orderFlag: false,
      type: 'string',
      format: '@',
      displayFlag: true,
    },
    {
      id: 'USER_NAME',
      label: '처리자',
      orderFlag: false,
      type: 'string',
      format: '@',
      displayFlag: true,
    },
    {
      id: 'REG_USER_ID',
      label: '처리자ID',
      orderFlag: false,
      type: 'string',
      format: '@',
      displayFlag: true,
    },
  ];

  const customized = {
    STATE: {
      makeBody: (rowObj, headsMap) => {
        return rowObj['STATE'] === '01' ? 'ON' : 'OFF';
      },
    },
  };

  const handleGetParams = (key, newParams) => {
    getParam(newParams);
  };

  const handleBridgeSubmit = () => {
    let setCpcWeightStr = '';
    let setCpmWeightStr = '';
    let result = {};
    const converKey = ['cpc', 'cpm'];
    for (let key of converKey) {
      for (let targetKey of weightList) {
        if (!!targetKey) {
          const codeInfo = allProductCodeList.find(
            (element) => element['value'] === targetKey
          );
          if (key === 'cpm') {
            setCpmWeightStr +=
              targetKey +
              ':' +
              params[under2camel(codeInfo['codeVal'] + '_' + key + '_weight')] +
              ',';
          } else if (key === 'cpc') {
            setCpcWeightStr +=
              targetKey +
              ':' +
              params[under2camel(codeInfo['codeVal'] + '_' + key + '_weight')] +
              ':' +
              params[under2camel(codeInfo['codeVal'] + '_' + key + '_send')] +
              ',';
          }
        }
      }
    }
    if (modal['type'] === 'edit') {
      result = {
        mediaScriptNo: String(params['mediaScriptNo']),
        setCpcWeightStr: setCpcWeightStr.slice(0, -1),
        setCpmWeightStr: setCpmWeightStr.slice(0, -1),
        cpcFlag: params['cpcFlag'],
        cpmFlag: params['cpmFlag'],
      };
    } else {
      result = {
        mediaScriptNo: String(params['mediaScriptNo']),
        setCpcWeightStr: setCpcWeightStr.slice(0, -1),
        setCpmWeightStr: setCpmWeightStr.slice(0, -1),
        bidUprc: params['bidUprc'],
        advrtsSendNum: params['advrtsSendNum'],
        siteName: params['siteName'],
        siteDesc: params['siteDesc'],
      };
    }
    handleSubmit(result);
  };

  const handleCheckbox = (e, aa) => {
    const { name, checked } = e.target;
    // const key = under2camel(lowKey + '_' + type + '_send');
    getParam({ ...params, [name]: checked ? '01' : '02' });
  };

  return (
    <>
      <Modal
        open={open}
        headerTitle={headerTitle}
        handleClose={handleModalClose}
        confirmBtnOpen={!isHistoryPage && !popupLoading}
        cancelBtnOpen={!popupLoading}
        cancelBtnTitle={!isHistoryPage ? t('취소') : t('확인')}
        confirmOnClick={handleBridgeSubmit}
        style={{ minWidth: 620 }}
        useForm={!isHistoryPage && type !== 'stop'}
      >
        {popupLoading ? (
          <CurrentStatus type="loading" option="useMinHeight" />
        ) : (
          <>
            {type === 'modify' && (
              <>
                <tr>
                  <th>{t('지면명')}</th>
                  <td>
                    <NewInput
                      type="tableInput"
                      name="siteName"
                      params={modal.params}
                      value={modal.params.siteName}
                      callBack={getParam}
                    />
                  </td>
                </tr>
                <tr>
                  <th>{t('지면 설명')}</th>
                  <td>
                    <NewInput
                      type="tableInput"
                      name="siteDesc"
                      params={modal.params}
                      value={modal.params.siteDesc}
                      callBack={getParam}
                    />
                  </td>
                </tr>
                <tr>
                  <th>{t('지면 카테고리')}</th>
                  <td>{params['ctgrNm']}</td>
                </tr>
                <tr>
                  <th>{t('사이즈')}</th>
                  <td>{params['imageSizeName']}</td>
                </tr>
                <tr>
                  <th>{t('구분')}</th>
                  <td>{params['pltfomTpNm']}</td>
                </tr>
                <tr>
                  <th>
                    <InfoTitleArea
                      title={t('CPC 가중치')}
                      tooltipTitle={t('체크박스 선택시 광고승인이 설정됩니다.')}
                      iconType="fainfoCircle"
                    />
                  </th>
                  <td>
                    <TargetingSetting
                      type="cpc"
                      handleClickSnackbar={handleClickSnackbar}
                      allProductCodeList={allProductCodeList}
                      params={params}
                      getParam={handleGetParams}
                      weightList={weightList}
                    />
                  </td>
                </tr>
                <tr>
                  <th>{t('CPM 가중치')}</th>
                  <td>
                    <TargetingSetting
                      type="cpm"
                      handleClickSnackbar={handleClickSnackbar}
                      allProductCodeList={allProductCodeList}
                      params={params}
                      getParam={handleGetParams}
                      weightList={weightList}
                    />
                  </td>
                </tr>
                <tr>
                  <th>{t('입찰단가')}</th>
                  <td>
                    <NewInput
                      type="tableInput"
                      name="bidUprc"
                      params={modal.params}
                      value={modal.params.bidUprc}
                      callBack={getParam}
                    />
                  </td>
                </tr>
                <tr>
                  <th>{t('광고송출개수')}</th>
                  <td>
                    <NewInput
                      type="tableInput"
                      name="advrtsSendNum"
                      params={modal.params}
                      value={modal.params.advrtsSendNum}
                      callBack={getParam}
                    />
                  </td>
                </tr>
              </>
            )}
            {(type === 'history' || type === 'mediaHistory') && (
              <NewTableContainer
                params={params}
                dataReqPromise={(f) => f}
                getParam={getParam}
                useFetch={false}
                useSearch={false}
                useTotal={false}
                useCustomTable
                propsList={data}
                propsHeadCells={makeHeadData(historyHead)}
                useToolBar={false}
                usePagenation={false}
                customized={customized}
              />
            )}
            {(type === 'edit' || type === 'multiModify') && (
              <>
                <tr>
                  <th>
                    <NewCheckbox
                      label={
                        <InfoTitleArea
                          title={t('CPC 가중치')}
                          tooltipTitle={t(
                            '체크박스 선택시 광고승인이 설정됩니다.'
                          )}
                          iconType="fainfoCircle"
                        />
                      }
                      name="cpcFlag"
                      onChange={handleCheckbox}
                      checked={params['cpcFlag'] === '01'}
                    />
                  </th>
                  <td>
                    <TargetingSetting
                      type="cpc"
                      handleClickSnackbar={handleClickSnackbar}
                      allProductCodeList={allProductCodeList}
                      params={params}
                      getParam={handleGetParams}
                      weightList={weightList}
                    />
                  </td>
                </tr>
                <tr>
                  <th>
                    <NewCheckbox
                      label={t('CPM 가중치')}
                      name="cpmFlag"
                      onChange={handleCheckbox}
                      checked={params['cpmFlag'] === '01'}
                    />
                  </th>
                  <td>
                    <TargetingSetting
                      type="cpm"
                      handleClickSnackbar={handleClickSnackbar}
                      allProductCodeList={allProductCodeList}
                      params={params}
                      getParam={handleGetParams}
                      weightList={weightList}
                    />
                  </td>
                </tr>
                {type === 'multiModify' && (
                  <>
                    <tr>
                      <th>
                        <NewCheckbox
                          label={t('입찰단가')}
                          name="bidUprcFlag"
                          onChange={handleCheckbox}
                          checked={params['bidUprcFlag'] === '01'}
                        />
                      </th>
                      <td>
                        <NewInput
                          type="tableInput"
                          name="bidUprc"
                          params={modal.params}
                          value={modal.params.bidUprc}
                          callBack={getParam}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <NewCheckbox
                          label={t('광고송출개수')}
                          name="sendNumFlag"
                          onChange={handleCheckbox}
                          checked={params['sendNumFlag'] === '01'}
                        />
                      </th>
                      <td>
                        <NewInput
                          type="tableInput"
                          name="advrtsSendNum"
                          params={modal.params}
                          value={modal.params.advrtsSendNum}
                          callBack={getParam}
                        />
                      </td>
                    </tr>
                  </>
                )}
              </>
            )}
          </>
        )}
      </Modal>
    </>
  );
};

export default withRouter(MediaDetailPopup);
